const E = "ark-";
function e(t) {
  return `${E}${t}`;
}
const u = {
  CHANGE: e("change"),
  INPUT: e("input"),
  CLICK: e("click"),
  FOCUS: e("focus"),
  BLUR: e("blur"),
  OPEN: e("open"),
  CLOSE: e("close"),
  TOGGLE: e("toggle"),
  SELECT: e("select"),
  REMOVE: e("remove"),
  SUBMIT: e("submit"),
  CANCEL: e("cancel"),
  CLEAR: e("clear"),
  EXPAND: e("expand"),
  COLLAPSE: e("collapse")
}, a = {
  bubbles: !0,
  composed: !0,
  cancelable: !1
};
function b(t, c, s, n = {}) {
  const o = new CustomEvent(c, {
    detail: s,
    bubbles: n.bubbles ?? a.bubbles,
    composed: n.composed ?? a.composed,
    cancelable: n.cancelable ?? a.cancelable
  });
  return t.dispatchEvent(o), o;
}
function i(t, c, s = 5e3) {
  return new Promise((n, o) => {
    const l = setTimeout(() => {
      o(new Error(`Timeout waiting for event: ${c}`));
    }, s);
    t.addEventListener(
      c,
      (r) => {
        clearTimeout(l), n(r);
      },
      { once: !0 }
    );
  });
}
export {
  E,
  u as a,
  b,
  e,
  i as w
};
//# sourceMappingURL=events-CkEPl0SM.js.map
